import { defineStore } from 'pinia'
import { Stories } from '../../../types/main'
import storiesList from './storiesList'

interface StoriesWithProjectId extends Stories {
    projectId: string
}

export const useStoriesStore = defineStore('stories', {
    state: () => ({
        stories: [] as StoriesWithProjectId[],
    }),
    actions: {
        async fetchProjectStories(projectId: string) {
            const newStories: StoriesWithProjectId[] = []
            // newStories.push(Object.assign({ projectId }, storiesList['marketplace']))
            newStories.push(Object.assign({ projectId }, storiesList['training-course']))
            newStories.push(Object.assign({ projectId }, storiesList['sightseeing-tour']))
            newStories.push(Object.assign({ projectId }, storiesList['knowledge-base']))
            newStories.push(Object.assign({ projectId }, storiesList['dev-roadmap']))
            this.stories = [...this.stories.filter(el => el.projectId !== projectId), ...newStories]
        },
    },
    getters: {
        getProjectStories(state) {
            return (projectId: string) => state.stories.filter(el => el.projectId === projectId)
        },
    },
})
